// @react
import React from 'react'
// @components
import Grid from '@bit/atd.web.grid'
import { makeStyles } from '@material-ui/core/styles'
import Spacer from '@bit/atd.web.spacer'
import colors from '@bit/atd.web.colors'

type PropTypes = {
  label: string | React.ReactNode
  badgeText: string
}

const useStyles = makeStyles(() => ({
  badge: {
    lineHeight: '10px',
    fontSize: '10px',
    color: colors.statusInProgress,
    border: `1px solid ${colors.statusInProgress}`,
    borderRadius: '5px',
    padding: '2px',
  },
}))

const BadgedLabel = ({ label, badgeText }: PropTypes) => {
  const classes = useStyles()

  return (
    <Grid container alignItems="center">
      <>
        {label}
        <Spacer size={5} />
        <div className={classes.badge}>{badgeText}</div>
      </>
    </Grid>
  )
}

export default BadgedLabel
